import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import {
  VulnerabilityUpdateSeverityMutationArgs,
  vulnerabilityUpdateSeverityMutationArgs
} from '../types/vulnerability-update-severity-mutation-args'
import { vulnerabilityType, GQLVulnerability } from '../types/vulnerability'
import { findByIDAndOrganizationID } from '../queries/helpers/vulnerability'

export const updateVulnerabilitySeverity: GraphQLFieldConfig<
  any,
  Context,
  VulnerabilityUpdateSeverityMutationArgs
> = {
  description: "Update a vulnerabilities' severity",
  type: new GraphQLNonNull(vulnerabilityType),
  args: vulnerabilityUpdateSeverityMutationArgs,
  resolve: async function resolve(
    _source,
    args,
    context
  ): Promise<GQLVulnerability> {
    const { input } = args

    if (!input) {
      throw new Error('mutation input parameter is required')
    }

    const { organizationID, vulnerabilityID, severity, overrideAll } = input

    const { connector } = context

    await connector.put(
      `/${organizationID}/orgtraces/trace/${vulnerabilityID}/severity`,
      {
        severity,
        override: overrideAll
      }
    )

    return findByIDAndOrganizationID(vulnerabilityID, organizationID, connector)
  }
}
